import React from "react"
import "./userAvatar.scss"
import { Avatar } from "@material-ui/core"
import { getUserName } from "../../library/utils/user/userUtils"

const UserAvatar = ({
  first_name = "",
  last_name = "",
  photo = "",
  user = null,
  ...avatarProps
}) => {
  const renderName = React.useMemo(() => {
    if (user) return getUserName(user)

    if (first_name && last_name) {
      return first_name + " " + last_name
    }

    return ""
  }, [first_name, last_name, user])

  // const renderPhoto = React.useMemo(() => {
  //   if (user) return getUserPhoto(user)
  //
  //   if (photo) return photo
  //
  //   return ""
  // }, [user, photo])

  return (
    <Avatar alt={renderName} src={photo} {...avatarProps}>
      {renderName[0]}
    </Avatar>
  )
}

export default UserAvatar
